import { render, staticRenderFns } from "./SBg.vue?vue&type=template&id=7e2940f4&"
import script from "./SBg.vue?vue&type=script&lang=ts&"
export * from "./SBg.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports